import { AxiosProgressEvent } from "axios";
import axios from ".";

// New session-based upload APIs
export const createUploadSession = async ({
  batchId,
  estimatedFiles,
}: {
  batchId: string;
  estimatedFiles: number;
}) => {
  return axios.post(`/image/create-upload-session`, {
    batch_id: batchId,
    estimated_files: estimatedFiles,
  });
};

export const uploadImageChunk = async ({
  sessionId,
  files,
  onUploadProgress,
}: {
  sessionId: string;
  files: File[];
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void;
}) => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("files", file);
  });

  return axios.post(`/image/upload-chunk?session_id=${sessionId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  });
};

export const reportSkippedFiles = async ({
  sessionId,
  skippedCount,
}: {
  sessionId: string;
  skippedCount: number;
}) => {
  return axios.post(
    `/image/upload-session/${sessionId}/report-skipped?skipped_count=${skippedCount}`
  );
};

export const getUploadSessionStatus = async ({
  sessionId,
}: {
  sessionId: string;
}) => {
  return axios.get(`/image/upload-session/${sessionId}`);
};
